var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartaicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.53325C0 3.52687 5.07056 0 9.62069 0C12.8769 0 15.9135 1.22075 17.5416 4.0375L14.5003 5.79975C13.9744 5.00882 13.2583 4.36103 12.4171 3.91519C11.5758 3.46934 10.6359 3.23953 9.68276 3.24663C7.00663 3.24663 3.82202 5.33662 3.82202 9.47388C3.82202 13.5114 6.86339 15.7368 9.93342 15.7368C12.0676 15.7368 13.8414 14.5469 14.8894 12.711L18 14.1455C16.2406 17.3138 13.0918 19 9.44165 19C4.84615 18.9953 0 15.4636 0 9.53325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartaicon);
export default __webpack_public_path__ + "static/media/cartaicon.fe6230a297bd2badca17a6c32cd0d5ec.svg";
export { ForwardRef as ReactComponent };